import axios from 'axios';
import { getApiConfig } from '../../environment';
import { ILightspeedClient } from './ILightspeedClient';
import { LightspeedConnectionStatus, LightspeedStoreMapping } from './lightspeedTypes';

const http = axios.create({ baseURL: getApiConfig().apiBaseUrl });

http.interceptors.request.use(async (config) => {
  const token = await window.Clerk?.session?.getToken?.({ template: 'Orderly_default' });
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export class LightspeedClientApi implements ILightspeedClient {
  async getStatus(franchiseName: string): Promise<LightspeedConnectionStatus> {
    const response = await http.get<LightspeedConnectionStatus>('/integrations/lightspeed/status', { params: { franchiseName } });
    return response.data;
  }

  async connect(franchiseName: string): Promise<string> {
    const response = await http.post<{ authorizationUrl: string }>('/integrations/lightspeed/connect', { franchiseName });
    return response.data.authorizationUrl;
  }

  async saveLocations(franchiseName: string, mappings: LightspeedStoreMapping[]): Promise<LightspeedConnectionStatus> {
    const response = await http.put<LightspeedConnectionStatus>('/integrations/lightspeed/locations', { franchiseName, mappings });
    return response.data;
  }

  async disconnect(franchiseName: string): Promise<void> {
    await http.delete('/integrations/lightspeed', { params: { franchiseName } });
  }
}
